
"use strict";
var React = require('react')
var Link = require('react-router').Link
var $ = require('jquery')

var Iframe = require("react-iframe");



var PDF = React.createClass({
componentDidMount(){
    $('html, body').animate({
        scrollTop: $('.navbar').height()
    }, 800);
},
  render: function() {
    var url2 = "../pdf/1459176277_0PUNOMOC ZA GLASANJE 2016..pdf";
    var url3 = "/pdf/"+this.props.params.id+"#pdf-container";
    return(
    <div className='container'>
        <div className='pdf-container'>
            <Iframe url={url3} className='pdfIframe'  width="100%" position='relative' height="620px"/>
        </div>
    </div>
      )
  }
});

module.exports = PDF;



/** WEBPACK FOOTER **
 ** ./modules/components/App/PDFdoc.js
 **/